export default __webpack_public_path__ + "static/media/de.js.270cee32.map";